<template>
  <div class="container" id="pastInfo" v-show="dispPastAnnounce">
    <div class="row">
      <div class="col-sm-10">
        <h3><em class="fa fa-bullhorn"></em> News and Announcements</h3>
        <div v-for="(item, idx) in announcements" :key="idx">
          <h4 v-html="item.title" v-if="idx >= 2"></h4>
          <p v-html="item.entry" v-if="idx >= 2"></p>
        </div>
      </div>
    </div>
    <p id="back-top"><a href="#top"><span></span>Back to Top</a></p>
  </div>
</template>

<script>
export default {
  name: 'announcements',
  props: [
    'announcements',
    'dispPastAnnounce'
  ],
  data () {
    return { }
  }
}
</script>

<style scoped>
  #pastInfo {
    display: block;
    background: rgba(255, 255, 255, 0.95);
    border-radius: 10px;
    width: 95%;
    max-width: 950px;
    margin-top: 30px;
    margin-bottom: 10px;
    padding: 10px 40px 40px 50px;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    font-family: 'Oswald', sans-serif;
    font-size: 12px;
    opacity: 0.98;
  }

  #pastInfo h3 {
    font-family: 'Oswald', sans-serif;
    font-weight: bold;
    color: #003595;
    margin: 30px 10px 10px 0px;
    font-size: 18px;
  }

  #pastInfo h4 {
    padding-top: 10px;
    font-family: 'Oswald', sans-serif;
    color: #003595;
    border-bottom: #83a2b6 solid;
    font-size: 16px;
  }

  #pastInfo p {
    padding-left: 20px;
    font-family: 'Open Sans', sans-serif;
    font-size: 12px;
  }

   .pastAnnounce {
    cursor: pointer;
  }
</style>
